import { makeRequest } from './helper.js'
const API_PATH = '/content-delivery/v1'

const fetchVacancy = async ({ vacancyId, jwt, domainSlug, baseTooUrl }) => {
  const url = `${baseTooUrl}${API_PATH}/${domainSlug}/vacancies/${vacancyId}`

  const headers = {
    'Content-Type': 'application/json',
  }
  if (jwt) {
    headers['Authorization'] = `Bearer ${jwt}`
  }

  const requestOptions = {
    method: 'GET',
    headers,
  }

  const { data } = await makeRequest({ url, requestOptions })
  return data
}

const fetchVacancyList = ({
  searchParams,
  page,
  sortBy,
  jwt,
  domainSlug,
  baseTooUrl,
}) => {
  const url = new URL(`${baseTooUrl}${API_PATH}/${domainSlug}/search/vacancies`)
  const queryParams = new URLSearchParams({ ...page, sortBy })
  const body = JSON.stringify(searchParams)

  const headers = {
    'Content-Type': 'application/json',
  }
  if (jwt) {
    headers['Authorization'] = `Bearer ${jwt}`
  }

  const requestOptions = {
    method: 'POST',
    headers,
    body,
  }

  return makeRequest({ url: `${url}?${queryParams}`, requestOptions })
}

const fetchVacancyCategoryOverview = async ({
  category,
  domainSlug,
  baseTooUrl,
}) => {
  const url = `${baseTooUrl}${API_PATH}/${domainSlug}/${category}`

  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  }

  const { data } = await makeRequest({ url, requestOptions })
  return data
}

const fetchVacancyLocationOverview = async ({
  region,
  domainSlug,
  baseTooUrl,
}) => {
  const url = `${baseTooUrl}${API_PATH}/${domainSlug}/regions/${region}/locations`

  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  }

  const { data } = await makeRequest({ url, requestOptions })
  return data
}

const fetchCompany = async ({ companySlug, domainSlug, baseTooUrl }) => {
  const url = `${baseTooUrl}${API_PATH}/${domainSlug}/companies/${companySlug}`
  const requestOptions = {
    method: 'GET',
  }

  const { data } = await makeRequest({ url, requestOptions })
  return data
}

const fetchCompanyList = ({ searchParams, page, domainSlug, baseTooUrl }) => {
  const url = new URL(`${baseTooUrl}${API_PATH}/${domainSlug}/search/companies`)
  const queryParams = new URLSearchParams(page)
  const body = JSON.stringify(searchParams)

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body,
  }

  return makeRequest({ url: `${url}?${queryParams}`, requestOptions })
}

const fetchTagList = async ({ domainSlug, baseTooUrl }) => {
  const url = `${baseTooUrl}${API_PATH}/${domainSlug}/tags`
  const requestOptions = {
    method: 'GET',
  }

  const { data } = await makeRequest({ url, requestOptions })
  return data
}

const fetchSite = async ({ domainSlug, baseTooUrl }) => {
  const url = `${baseTooUrl}${API_PATH}/${domainSlug}/sites`
  const requestOptions = {
    method: 'GET',
  }

  const { data } = await makeRequest({ url, requestOptions })
  return data
}

const fetchLocationList = async ({ domainSlug, baseTooUrl }) => {
  const url = `${baseTooUrl}${API_PATH}/${domainSlug}/locations`
  const requestOptions = {
    method: 'GET',
  }

  const { data } = await makeRequest({ url, requestOptions })
  return data
}

const fetchJobAlertList = ({ jwt, domainSlug, baseTooUrl }) => {
  const url = new URL(`${baseTooUrl}${API_PATH}/${domainSlug}/jobalerts`)

  const headers = {
    'Content-Type': 'application/json',
  }
  if (jwt) {
    headers['Authorization'] = `Bearer ${jwt}`
  }

  const requestOptions = {
    method: 'GET',
    headers,
  }

  return makeRequest({ url, requestOptions })
}

const fetchJobAlert = ({ jobAlertToken, domainSlug, baseTooUrl }) => {
  const url = new URL(
    `${baseTooUrl}${API_PATH}/${domainSlug}/jobalerts/${jobAlertToken}`,
  )

  const headers = {
    'Content-Type': 'application/json',
  }

  const requestOptions = {
    method: 'GET',
    headers,
  }

  return makeRequest({ url, requestOptions })
}

const createJobAlert = ({ payload, domainSlug, baseTooUrl }) => {
  const url = `${baseTooUrl}${API_PATH}/${domainSlug}/jobalerts`
  const body = JSON.stringify(payload)
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body,
  }

  return makeRequest({ url, requestOptions })
}

const updateJobAlert = ({ token, payload, jwt, domainSlug, baseTooUrl }) => {
  const url = new URL(
    `${baseTooUrl}${API_PATH}/${domainSlug}/jobalerts/${token}`,
  )
  const body = JSON.stringify(payload)

  const headers = {
    'Content-Type': 'application/json',
  }
  if (jwt) {
    headers['Authorization'] = `Bearer ${jwt}`
  }

  const requestOptions = {
    method: 'PUT',
    headers,
    body,
  }

  return makeRequest({ url, requestOptions })
}

const deleteJobAlert = ({ token, jwt, domainSlug, baseTooUrl }) => {
  const url = new URL(
    `${baseTooUrl}${API_PATH}/${domainSlug}/jobalerts/${token}`,
  )

  const headers = {
    'Content-Type': 'application/json',
  }
  if (jwt) {
    headers['Authorization'] = `Bearer ${jwt}`
  }

  const requestOptions = {
    method: 'DELETE',
    headers,
  }

  return makeRequest({ url, requestOptions })
}

const unsubscribeFromJobAlert = ({ token, domainSlug, baseTooUrl }) => {
  const url = `${baseTooUrl}${API_PATH}/${domainSlug}/jobalerts/${token}/unsubscribe`
  const requestOptions = {
    method: 'POST',
  }

  return makeRequest({ url, requestOptions })
}

const deleteAllJobAlerts = ({ jwt, domainSlug, baseTooUrl }) => {
  const url = new URL(`${baseTooUrl}${API_PATH}/${domainSlug}/jobalerts`)

  const headers = {
    'Content-Type': 'application/json',
  }
  if (jwt) {
    headers['Authorization'] = `Bearer ${jwt}`
  }

  const requestOptions = {
    method: 'DELETE',
    headers,
  }

  return makeRequest({ url, requestOptions })
}

export {
  fetchVacancy,
  fetchVacancyList,
  fetchVacancyCategoryOverview,
  fetchVacancyLocationOverview,
  fetchCompany,
  fetchCompanyList,
  fetchTagList,
  fetchSite,
  fetchLocationList,
  fetchJobAlertList,
  fetchJobAlert,
  createJobAlert,
  updateJobAlert,
  deleteJobAlert,
  unsubscribeFromJobAlert,
  deleteAllJobAlerts,
}
